import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import i18n from '@/i18n'
import { resetQueries } from '@/utils'

import { RESERVATION_NOTES_QUERY_KEY } from './get-reservation-notes'

export type UpdateReservationNoteRequest = {
  reservationId: string
  noteId: number
  title: string
  noteBody: string
}

const updateReservationNote = async ({
  reservationId,
  noteId,
  title,
  noteBody,
}: UpdateReservationNoteRequest) => {
  const result = await authAPI.put(`/reservation/${reservationId}/notes/${noteId}`, {
    noteBody,
    title,
  })

  return result.data
}

export const useUpdateReservationNote = () => {
  return useMutation({
    mutationFn: updateReservationNote,
    onError: () => {
      toastFactory.error(i18n.t('common:errors.generic'))
    },
    onSuccess: async () => {
      await resetQueries([RESERVATION_NOTES_QUERY_KEY])
      toastFactory.success(i18n.t('reservations:details.apiMessages.updateSuccess'))
    },
  })
}
